import DailyFerryDetail from "@/controllers/daily_ferry/daily-ferry-detail";
import CustomDailyFerryDetail from "@/components/custom/daily_ferry/DailyFerryDetail.vue";
import SelectAllService from '@/services/SelectAllService.js';
import ValidationService from '@/services/ValidationService';
import 'flatpickr/dist/flatpickr.css';
import flatPickr from 'vue-flatpickr-component';
import axios from "axios";

export default {
  extends: DailyFerryDetail,
  mixins: [SelectAllService, ValidationService],
  components: {
    CustomDailyFerryDetail,
    flatPickr
  },
  data() {
    return {
      duplicateForm: {
        from_date: "",
        to_date: "",
        skip_holiday: null,
      },
      submitted: false,
      holidayOptions: [
        {id: 1, text: "Teacher Holiday"},
        {id: 2, text: "Student Holiday"}
      ],
    }
  },
  computed: {
    isFromDateRequired() {
      return this.submitted && !this.duplicateForm.from_date;
    },
    isToDateRequired() {
      return this.submitted && !this.duplicateForm.to_date;
    },
    isDateError() {
      if (!this.submitted) return false;
      if (!this.duplicateForm.from_date || !this.duplicateForm.to_date) return false;
      return new Date(this.duplicateForm.to_date) < new Date(this.duplicateForm.from_date);
    }
  },
  watch: {
    'DFData.user'(users) {
      if (Array.isArray(users)) {
        const checked = this.selectedAllToggle && this.selectedIds.length === 0;
        this.currentCbs = Array(users.length).fill(checked);
        this.selectedAllCb = checked && users.length > 0;
      }
    }
  },

  methods: {
    duplicateDailyPickUps() {
      this.submitted = true;
      this.validationErrors = {};
      if (this.isFromDateRequired || this.isToDateRequired || this.isDateError) {
        return;
      }

      let selectedIds = [...this.selectedIds];
      
      if (this.selectedAllToggle)  {
        selectedIds = this.DFData.user.map(user => user.ferry_pick_up_id);
      }

      if (!selectedIds.length) {
        this.$notification.error("Select At Least One User.", {
            timer: 3,
            position: "bottomCenter",
        });
        return;
      }

      const request = {
        driver_id: this.DFData.driver_id,
        ferry_id: this.DFData.ferry_id,
        route_id: this.DFData.route_id,
        teacher_id: this.DFData.teacher_id,
        from_date: this.duplicateForm.from_date,
        to_date: this.duplicateForm.to_date,
        skip_holiday: this.duplicateForm.skip_holiday,
        ferry_pickup_id: selectedIds,
        loginId: this.$store.state.user.id,
        campus_id: this.$store.state.user.campus_id
      }

      this.disabled = true;
      this.isLoading = true;
      axios.post('dailyFerry/create', request )
        .then((res) => {
          if (res.data.success == true) {
            this.$notification.success("Daily Ferry Added Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({ name: 'dailyFerryList' })
          } else {
            this.disabled = false;
            this.isLoading = false;
            this.$notification.error(res.data.message, {
              timer: 3,
              position: "bottomCenter"
            });
          }
          this.disabled = false;
        })
        .catch((error) => {
          this.disabled = false;
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          if (error.response.status == 422) {
            this.printValidationError(error.response);
            const errors = (error.response.data && error.response.data.errors) || {};
            const keys = Object.keys(errors);
            const onlyPickupErrors = keys.length > 0 && keys.every(k => k.startsWith('ferry_pickup_id'));
            if (!onlyPickupErrors && error.response.data.message) {
              this.$notification.error(error.response.data.message, {
                timer: 3,
                position: "bottomCenter",
              });
            }
          }
          this.isLoading = false;
        });
    },
    skipTypeChange(typeId) {
      if (typeId == this.duplicateForm.skip_holiday) {
        this.duplicateForm.skip_holiday = null;
      }
    },

    getPickupError(pickupId) {
      if (!this.validationErrors) return null;
      const selectedOrderedIds = this.selectedAllToggle
        ? this.DFData.user.map(user => String(user.ferry_pick_up_id))
        : this.selectedIds.map(id => String(id));
      const idx = selectedOrderedIds.indexOf(String(pickupId));
      const indexedKey = `ferry_pickup_id.${idx}`;
      return (this.validationErrors[indexedKey] && this.validationErrors[indexedKey][0]) || null;
    },

    selectToggle(id, index) {
      const itemCountOnPage = this.DFData.user.length; 
      console.log(itemCountOnPage);
      this.selectToggleWithCount(id, index, itemCountOnPage);
    }
  }
}
